import React from 'react';
import PropTypes from 'prop-types';

import TimeCounter from '../TimeCounter';
import {
  RecordingView,
  RecordingLabel,
  StyledStopIcon,
} from './styles';
import texts from './texts.json';

const AudioMemoControls = ({
  onStopRecording,
}) => (
  <RecordingView>
    <RecordingLabel>
      {texts.recordingLabel}
      <TimeCounter run />
    </RecordingLabel>
    <StyledStopIcon onClick={onStopRecording} />
  </RecordingView>
);

AudioMemoControls.propTypes = {
  onStopRecording: PropTypes.func.isRequired,
};

export default AudioMemoControls;
